<template>
  <div class="rightMenu">
    <div class="backToTop">
      <div class="box">
        <a><img src="https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/onelink.mdata.main.ui.pro/rightNotice.png" alt=""><i v-show="showNoticeInfo" class="hasNotice"></i></a>
        <a href="#" @click="goToHref('/notification')"><span>公告<br/>通知</span></a>
      </div>
    </div>
    <!-- <div class="backToTop">
      <div class="box">
        <a><img src="https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/onelink.mdata.main.ui.pro/customerService.png" alt=""></a>
        <a href='https://onelinkplus.udesk.cn/im_client/?web_plugin_id=52506&cur_title=%E4%B8%80%E9%93%BE%E7%BD%91&src_url=&cur_url=http%253A%252F%252Fex.onelinkplus.com%252Fportal%252Findex&pre_url=http%3A%2F%2Fex.onelinkplus.com%2Fportal%2Findex' target="提供丰富的全球 采购资源与协同服务"><span>咨询<br/>客服</span></a>
      </div>
    </div> -->
    <div class="backToTop">
      <div class="box">
        <a @click="backTop"><img src="https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/onelink.mdata.main.ui.pro/arrowUp.png" alt=""></a>
        <a @click="backTop"><span>返回<br/>顶部</span></a>
      </div>
    </div>
  </div>
</template>
<script>
  import { mapState } from 'vuex'
  export default {
    props: [],
    data(){
      return{
        showNoticeInfo:false
      }
    },
    mounted(){
      this.touchFn();
      this.hasNotice()
    },
    computed: mapState([
      'KP'
    ]),
    methods: {
      backTop(){
        $('html,body').animate({scrollTop: 0},'slow');
      },
      goToHref(val){
        if(this.getToken('isLogin') == ''){
          this.$router.push({path:'/login'});
        }else{
          this.$router.push({path: val})
        }
        
      },
      touchFn(){
        $('.backToTop').on("touchend", function () {
          $(this).children('.box').animate({top: '-48px'}, 'slow')
          $(this).children('.box').animate({top: '0px'}, 'slow')
        });
      },
//      判断是否有公告通知
      hasNotice(){
        if(this.getToken('isLogin') == 100){
  
          if(JSON.parse(this.getToken('noticeInfos'))){
            if(JSON.parse(this.getToken('noticeInfos')).length>0){
//            console.log('you');
              this.showNoticeInfo = true;
            }else{
              this.showNoticeInfo = false;
            }
          }else{
            this.showNoticeInfo = false;
          }
          
        }else{
          this.showNoticeInfo = false;
        }
        
      },
      clickCustrome(){
        window.location.href='https://onelinkplus.udesk.cn/im_client/?web_plugin_id=52506&cur_title=%E4%B8%80%E9%93%BE%E7%BD%91&src_url=&cur_url=http%253A%252F%252Fex.onelinkplus.com%252Fportal%252Findex&pre_url=http%3A%2F%2Fex.onelinkplus.com%2Fportal%2Findex';
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/backToTop/index.vue